import ContactInformation from './ContactInformationContainer';

export default ContactInformation;
